import { useRef } from 'react';

import {
  Button,
  Center,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Spinner,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

import { CloseCircleOutline, DeleteOutline } from '@aslanpay/portal-common-lib';

import useFetchIndividual from 'app/hooks/useFetchIndividual';

import EditTerminateEmployeeForm from '../EditEmployeeTerminationDateForm';

import RemoveEmployeeTerminationDateModal from '../RemoveEmployeeTerminationDateModal';

import { EditEmployeeTerminationDateModalProps } from './types';

function EditEmployeeTerminationDateModal({
  id,
  isOpen,
  onClose,
  onEditTerminate,
}: EditEmployeeTerminationDateModalProps) {
  const submitButtonRef = useRef<HTMLElement>(null);

  const {
    isOpen: isRemoveTerminationDateOpen,
    onOpen: onOpenRemoveTerminationDate,
    onClose: onCloseRemoveTerminationDate,
  } = useDisclosure();

  const { data: employee, isLoading: isLoadingEmployee } = useFetchIndividual(id, isOpen);

  const handleRemove = () => {
    onEditTerminate();
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen && !isRemoveTerminationDateOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <HStack>
              <Text as="h6">Edit leave date</Text>
              <Spacer />
              <IconButton
                variant="link"
                icon={<CloseCircleOutline boxSize="30px" />}
                aria-label="Close edit leave employee"
                onClick={onClose}
              />
            </HStack>
          </ModalHeader>
          <ModalBody mt="20px">
            {!isLoadingEmployee && employee && employee.terminationDate ? (
              <EditTerminateEmployeeForm
                employee={employee}
                ref={submitButtonRef}
                onConfirm={onEditTerminate}
                onClose={onClose}
              />
            ) : (
              <Center width="full" height="full" flexGrow={1}>
                <Spinner color="brand.purple" size="xl" mb="50px" />
              </Center>
            )}
          </ModalBody>
          <ModalFooter ref={submitButtonRef}>
            <Button mr="20px" variant="link" size="sm" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="outline"
              className="danger"
              size="sm"
              leftIcon={<DeleteOutline boxSize="20px" />}
              onClick={onOpenRemoveTerminationDate}
            >
              Remove date
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {!isLoadingEmployee && employee && employee.terminationDate && (
        <RemoveEmployeeTerminationDateModal
          employee={employee}
          isOpen={isRemoveTerminationDateOpen}
          onRemove={handleRemove}
          onClose={onCloseRemoveTerminationDate}
        />
      )}
    </>
  );
}

export default EditEmployeeTerminationDateModal;
